import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from "./plugins/vuetify";
import './assets/css/font.css'
import './assets/css/styles.css'
import VueI18n from 'vue-i18n'
import en_file from './language/en_US'
import th_file from './language/th_TH'
import cn_file from './language/zh_CN'

// Accounting.js
const accounting = require('accounting-js')

import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(require('vue-moment'));

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: store.state.locale,
  messages: {
    en: en_file,
    th: th_file,
    cn: cn_file
  },
  fallbackLocale: "en"
});
// Set i18n as global method
Vue.prototype._i18n = i18n;

Vue.filter('numberFormat', function (value, precision = 0) {
    return accounting.formatMoney(value, {
        symbol: '',
        precision: precision
    })
})

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

